import { apiSlice } from "./apiSlice";

export const contractApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 싸인 완료 계약서 PDF 파일 저장
        signContractPdf: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}/sign_contract/pdf`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 전자계약 발송
        sendContract: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}/send`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 차량 반납처리
        returnContract: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}/return`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 리스트 조회
        getContractGroupList: build.query({
            query: (params) => ({
                url: "/api/user/contract_group/v1",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),

        // 계약서 저장
        postContractGroup: build.mutation({
            query: (body) => ({
                url: "/api/user/contract_group/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 수정
        putContractGroup: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 삭제
        deleteContractGroup: build.mutation({
            query: ({ contractGroupId }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),

        // 계약서 단건 상세조회 (계약 그룹 내 개별 계약 조회)
        getContractGroupContractById: build.query({
            query: ({ contractGroupId, contractId }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 계약 그룹 상세조회 (계약 그룹 전체 상세조회)
        getContractGroupById: build.query({
            query: (contractGroupId) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 계약서 단건 수정
        putContract: build.mutation({
            query: ({ contractGroupId, contractId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 전자계약 URL 조회
        getContractUrl: build.mutation({
            query: ({ contractGroupId, contractId }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}/url`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 메모 리스트 조회
        getMemoList: build.query({
            query: (contractGroupId) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/memo`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 메모 등록
        postMemo: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/memo`,
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 단건 기준 단가 요금 수정
        putContractRentPriceItem: build.mutation({
            query: ({ contractGroupId, contractId, rentPriceItemId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract/${contractId}/rent_price_item/${rentPriceItemId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약서 단건 추가
        postContract: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/contract`,
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 계약 노출 처리
        updateContractGroupExposedYn: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/exposed_yn`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 청구 입금액 정보조회
        getDepositPriceList: build.query({
            query: (contractGroupId) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/deposit_price`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 입금액 생성
        postDepositPrice: build.mutation({
            query: ({ contractGroupId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/deposit_price`,
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),

        // 입금액 수정
        putDepositPrice: build.mutation({
            query: ({ contractGroupId, chargeDepositId, body }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/deposit_price/${chargeDepositId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 입금액 삭제
        deleteDepositPrice: build.mutation({
            query: ({ contractGroupId, chargeDepositId }) => ({
                url: `/api/user/contract_group/v1/${contractGroupId}/deposit_price/${chargeDepositId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useSignContractPdfMutation,
    useSendContractMutation,
    useReturnContractMutation,
    useGetContractGroupListQuery,
    usePostContractGroupMutation,
    usePutContractGroupMutation,
    useDeleteContractGroupMutation,
    useGetContractGroupContractByIdQuery,
    useGetContractGroupByIdQuery,
    usePutContractMutation,
    useGetContractUrlMutation,
    useGetMemoListQuery,
    usePostMemoMutation,
    usePutContractRentPriceItemMutation,
    usePostContractMutation,
    useUpdateContractGroupExposedYnMutation,
    useGetDepositPriceListQuery,
    usePostDepositPriceMutation,
    usePutDepositPriceMutation,
    useDeleteDepositPriceMutation,
} = contractApi;
